import React from 'react';
import { useGetInspectionScoringSuspense } from '../../../services/api/generated/client';
import { unwrapModel } from '../../../services/api/unwrapModel';
import HazardFindingsTable from '../HazardFindingsTable/HazardFindingsTable';
import usePages from '../../../hooks/usePages';
import { buildPaginationFromResponse } from '../../../services/pagination';
import useExpandableAccordion from '../../../hooks/useExpandableAccordion';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
const HazardFindingsContent = ({ inspection }) => {
    const { canEditInspection } = useInspectionDetailContext();
    const { handleExpand, expandedIndex } = useExpandableAccordion();
    const { incrementPage, decrementPage, page } = usePages(() => {
        handleExpand(undefined);
    });
    const { data: response, isFetching, refetch, } = useGetInspectionScoringSuspense(inspection.id, {
        page,
        should_paginate: 1,
    });
    const hazardsWithScoring = unwrapModel(response);
    const pagination = buildPaginationFromResponse(response, incrementPage, decrementPage);
    return (React.createElement(HazardFindingsTable, { inspection: inspection, handleExpand: handleExpand, expandedIndex: expandedIndex, onHazardsTableMutated: refetch, hazardsWithScoring: hazardsWithScoring, isFetching: isFetching, pagination: pagination, canEdit: canEditInspection }));
};
export default HazardFindingsContent;
